import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { HeaderApplication } from '@Components/index';

import styles from './dashboard.module.css';

const { Content } = Layout;

const Dashboard: React.FC = () => {
  return (
    <Layout>
      <HeaderApplication />
      <Content className={styles.contentSection}>
        <Outlet />
      </Content>
    </Layout>
  );
};

export default Dashboard;
